import i18n, { TFunction, TOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { formatCurrency, formatDate, formatNumber } from './i18next-format';

const defaultLocale = 'en-GB';
const locale = 'en-GB';

export const setupI18next = (resources: TOptions): Promise<TFunction> => {
  return i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: defaultLocale,
    react: {
      // https://react.i18next.com/latest/trans-component#trans-props
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i']
    },
    interpolation: {
      format: (value: any, format: any, lng: any, options: any) => {
        /**
         * I am unable to get the format to be undefined in a test but as this is a type
         * in i18next it can be undefined...
         */
        /* istanbul ignore next */
        if (format === undefined) return value;

        if (format.startsWith('currency')) return formatCurrency(value, format, lng, options);
        if (format.startsWith('number')) return formatNumber(value, format, lng);
        if (format.startsWith('date')) return formatDate(value, format, lng);
        return value;
      }
    }
  });
};

export const setLocale = (newLocale: string): void => {
  if (i18n.language === newLocale) {
    return;
  }
  i18n.changeLanguage(newLocale);
  document.documentElement.lang = newLocale;
};
